import { useEffect, useRef, DependencyList } from 'react';

/**
 * Returns a stable callback reference that always calls the latest version of the provided function.
 *
 * @param callbackFn - The callback function to wrap
 * @param deps - Dependencies array that determines when the callback should be updated
 */
export default <T extends (...args: any[]) => any>(callbackFn: T, deps: DependencyList): T => {
    const callbackRef = useRef<T>(callbackFn);

    // Create a stable wrapper function that always calls the latest callback
    const stableCallback = useRef<T>(((...args: any[]) => callbackRef.current(...args)) as T);

    // Update the ref whenever dependencies change
    useEffect(() => {
        callbackRef.current = callbackFn;
    }, deps);

    return stableCallback.current;
};
